// THUMBNAILS

// Options
import seats from "../assets/thumbnails/options/seats.jpg";
import noSeats from "../assets/thumbnails/options/no_seats.jpg";
import people from "../assets/thumbnails/options/people.jpg";
import noPeople from "../assets/thumbnails/options/no_people.jpg";
import camera from "../assets/thumbnails/options/camera.jpg";
import noCamera from "../assets/thumbnails/options/no_camera.jpg";

// Decals
import decal1Airbus from "../assets/thumbnails/decals/decal1_airbus.jpg";
import decal2Airbus from "../assets/thumbnails/decals/decal2_airbus.jpg";
import decal3Airbus from "../assets/thumbnails/decals/decal3_airbus.jpg";
import decal4Airbus from "../assets/thumbnails/decals/decal4_airbus.jpg";
import decal1Electra from "../assets/thumbnails/decals/decal1_electra.jpg";
import decal2Electra from "../assets/thumbnails/decals/decal2_electra.jpg";
import decal3Electra from "../assets/thumbnails/decals/decal3_electra.jpg";
import decal4Electra from "../assets/thumbnails/decals/decal4_electra.jpg";

// Colors
import whiteMaterial from "../assets/thumbnails/colors/white_steel.jpg";
import blueMaterial from "../assets/thumbnails/colors/blue.jpg";
import blackMaterial from "../assets/thumbnails/colors/black.jpg";
import yellowMaterial from "../assets/thumbnails/colors/yellow.jpg";
import redMaterial from "../assets/thumbnails/colors/red.jpg";
import greenMaterial from "../assets/thumbnails/colors/green.jpg";

//Materials
import carbonFiber from "../assets/thumbnails/materials/carbon_fiber.jpg";
import steel from "../assets/thumbnails/colors/white_steel.jpg";

//Environments
import exteriorAirbus from "../assets/thumbnails/environment/exterior_airbus.jpg";
import hangarAirbus from "../assets/thumbnails/environment/hangar_airbus.jpg";
import skyAirbus from "../assets/thumbnails/environment/sky_airbus.jpg";
import exteriorElectra from "../assets/thumbnails/environment/exterior_electra.jpg";
import hangarElectra from "../assets/thumbnails/environment/hangar_electra.jpg";
import skyElectra from "../assets/thumbnails/environment/sky_electra.jpg";

// Animations
import propellerOnAirbus from "../assets/thumbnails/animations/propeller_on_airbus.gif";
import propellerOffAirbus from "../assets/thumbnails/animations/propeller_off_airbus.jpg";
import propellerOnElectra from "../assets/thumbnails/animations/propeller_on_electra.gif";
import propellerOffElectra from "../assets/thumbnails/animations/propeller_off_electra.jpg";

//Cameras
import camera1 from "../assets/thumbnails/cameras/camera1.jpg";
import camera2 from "../assets/thumbnails/cameras/camera2.jpg";
import camera3 from "../assets/thumbnails/cameras/camera3.jpg";

//Exterior Cameras
import extCamera1 from "../assets/thumbnails/cameras/exterior/camera_1.jpg";
import extCamera2 from "../assets/thumbnails/cameras/exterior/camera_2.jpg";
import extCamera3 from "../assets/thumbnails/cameras/exterior/camera_3.jpg";

// Cinematic Controls
import iconPlay from "../assets/icons/icon_play.svg";
import iconPause from "../assets/icons/icon_pause.svg";
import iconStop from "../assets/icons/icon_stop.svg";
import iconReset from "../assets/icons/icon_reset.svg";
import iconCamera from "../assets/icons/icon_camera.svg";

const list = [
  {
    name: "Material",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: "Material",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "Steel",
            image: steel,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bm: "s",
              },
              type: "select",
            },
          },
          {
            name: "Carbon Fiber",
            image: carbonFiber,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bm: "cf",
              },
              type: "select",
            },
          },
        ],
      },
    ],
  },
  {
    name: "Color",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: "Color",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "Blue",
            image: blueMaterial,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bc: "bl",
              },
              type: "select",
            },
          },
          {
            name: "Red",
            image: redMaterial,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bc: "re",
              },
              type: "select",
            },
          },
          {
            name: "Green",
            image: greenMaterial,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bc: "gr",
              },
              type: "select",
            },
          },
          {
            name: "Yellow",
            image: yellowMaterial,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bc: "ye",
              },
              type: "select",
            },
          },
          {
            name: "White",
            image: whiteMaterial,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bc: "wh",
              },
              type: "select",
            },
          },
          {
            name: "Black",
            image: blackMaterial,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bc: "bla",
              },
              type: "select",
            },
          },
        ],
      },
    ],
  },
  {
    name: "Decals",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: "Decals",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "Decal 1",
            image: decal1Airbus,
            model: "airbus",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bd: "d1",
              },
              type: "select",
            },
          },
          {
            name: "Decal 2",
            image: decal2Airbus,
            model: "airbus",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bd: "d2",
              },
              type: "select",
            },
          },
          {
            name: "Decal 3",
            image: decal3Airbus,
            model: "airbus",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bd: "d3",
              },
              type: "select",
            },
          },
          {
            name: "Decal 4",
            image: decal4Airbus,
            model: "airbus",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bd: "d4",
              },
              type: "select",
            },
          },
          {
            name: "Decal 1",
            image: decal1Electra,
            model: "electra",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bd: "d1",
              },
              type: "select",
            },
          },
          {
            name: "Decal 2",
            image: decal2Electra,
            model: "electra",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bd: "d2",
              },
              type: "select",
            },
          },
          {
            name: "Decal 3",
            image: decal3Electra,
            model: "electra",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bd: "d3",
              },
              type: "select",
            },
          },
          {
            name: "Decal 4",
            image: decal4Electra,
            model: "electra",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bd: "d4",
              },
              type: "select",
            },
          },
        ],
      },
    ],
  },
  {
    name: "Decal color",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: "Decal color",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "Blue",
            image: blueMaterial,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bdc: "bl",
              },
              type: "select",
            },
          },
          {
            name: "Red",
            image: redMaterial,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bdc: "re",
              },
              type: "select",
            },
          },
          {
            name: "Green",
            image: greenMaterial,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bdc: "gr",
              },
              type: "select",
            },
          },
          {
            name: "Yellow",
            image: yellowMaterial,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bdc: "ye",
              },
              type: "select",
            },
          },
          {
            name: "White",
            image: whiteMaterial,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bdc: "wh",
              },
              type: "select",
            },
          },
          {
            name: "Black",
            image: blackMaterial,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                bdc: "bla",
              },
              type: "select",
            },
          },
        ],
      },
    ],
  },
  {
    name: "Options",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: "Options",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "Seats hidden",
            image: noSeats,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                mv: "se_h",
              },
              type: "select",
            },
          },
          {
            name: "Seats visible",
            image: seats,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                mv: "se_v",
              },
              type: "select",
            },
          },
          {
            name: "Camera hidden",
            image: noCamera,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                mv: "ca_h",
              },
              type: "select",
            },
          },
          {
            name: "Camera visible",
            image: camera,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                mv: "ca_v",
              },
              type: "select",
            },
          },
          {
            name: "People hidden",
            image: noPeople,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                mv: "pe_h",
              },
              type: "select",
            },
          },
          {
            name: "People visible",
            image: people,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                mv: "pe_v",
              },
              type: "select",
            },
          },
        ],
      },
    ],
  },
  {
    name: "Options Interior",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: "Options",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "Interior 1",
            image: noPeople, //interior 1
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                mv: "int1_v",
              },
              type: "select",
            },
          },
          {
            name: "Interior 2",
            image: people, //interior 2
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                mv: "int2_v",
              },
              type: "select",
            },
          },
        ],
      },
    ],
  },
  {
    name: "Animate propeller",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: "Animate propeller",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "On",
            image: propellerOnAirbus,
            model: "airbus",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                ap: "pl",
              },
              type: "select",
            },
          },
          {
            name: "Off",
            image: propellerOffAirbus,
            model: "airbus",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                ap: "st",
              },
              type: "select",
            },
          },
          {
            name: "On",
            image: propellerOnElectra,
            model: "electra",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                ap: "pl",
              },
              type: "select",
            },
          },
          {
            name: "Off",
            image: propellerOffElectra,
            model: "electra",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                ap: "st",
              },
              type: "select",
            },
          },
        ],
      },
    ],
  },
  {
    name: "Interior",
    image: "",
    model: "electra",
    muiIcon: "",
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: "Interior",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "Camera 1",
            image: camera1,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                int_cam: "c1",
              },
              type: "select",
            },
          },
          {
            name: "Camera 2",
            image: camera2,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                int_cam: "c2",
              },
              type: "select",
            },
          },
          {
            name: "Camera 3",
            image: camera3,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                int_cam: "c3",
              },
              type: "select",
            },
          },
          {
            name: "Go to exterior",
            image: exteriorElectra,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                reset_cam: "true",
              },
              type: "select",
            },
          },
        ],
      },
    ],
  },
  {
    name: "Camera views",
    image: "",
    model: "airbus",
    muiIcon: "",
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: "Exterior",
        image: "",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "Camera 1",
            image: extCamera1,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                ext_cam: "c1",
              },
              type: "select",
            },
          },
          {
            name: "Camera 2",
            image: extCamera2,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                ext_cam: "c2",
              },
              type: "select",
            },
          },
          {
            name: "Camera 3",
            image: extCamera3,
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                ext_cam: "c3",
              },
              type: "select",
            },
          },
        ],
      },
    ],
  },
  {
    name: "Environment",
    image: "",
    muiIcon: "",
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: "Environment",
        muiIcon: "",
        action: {
          type: "select",
        },
        subActions: [
          {
            name: "Exterior",
            image: exteriorAirbus,
            model: "airbus",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                env: "e1",
                ap: "st",
              },
              type: "select",
            },
          },
          {
            name: "Hangar",
            image: hangarAirbus,
            model: "airbus",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                env: "e2",
                ap: "st",
              },
              type: "select",
            },
          },
          {
            name: "Sky",
            image: skyAirbus,
            model: "airbus",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                env: "e3",
                ap: "pl",
              },
              type: "select",
            },
          },
          {
            name: "Exterior",
            image: exteriorElectra,
            model: "electra",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                env: "e1",
                ap: "st",
              },
              type: "select",
            },
          },
          {
            name: "Hangar",
            image: hangarElectra,
            model: "electra",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                env: "e2",
                ap: "st",
              },
              type: "select",
            },
          },
          {
            name: "Sky",
            image: skyElectra,
            model: "electra",
            muiIcon: "",
            subActions: [],
            action: {
              descriptor: {
                env: "e3",
                ap: "pl",
              },
              type: "select",
            },
          },
        ],
      },
    ],
  },
  {
    name: "Cinematic",
    image: "",
    action: {
      type: "select",
      descriptor: {
        media_tab_type: "cinematic",
      },
    },
    subActions: [
      {
        name: "Play",
        image: iconPlay,
        muiIcon: "",
        subActions: [],
        action: {
          descriptor: {
            cin: "pl",
          },
          type: "select",
        },
      },
      {
        name: "Pause",
        image: iconPause,
        muiIcon: "",
        subActions: [],
        action: {
          descriptor: {
            cin: "pa",
          },
          type: "select",
        },
      },
      {
        name: "Stop",
        image: iconStop,
        muiIcon: "",
        subActions: [],
        action: {
          descriptor: {
            cin: "st",
          },
          type: "select",
        },
      },
      // {
      //   name: "TimeSlider",
      //   image: "",
      //   muiIcon: "",
      //   subActions: [],
      //   action: {
      //     descriptor: {
      //       cinematic_scrub: "0.5",
      //     },
      //     type: "select",
      //   },
      // },
      {
        name: "Reset Camera",
        image: iconReset,
        muiIcon: "",
        subActions: [],
        action: {
          descriptor: {
            reset_cam: "true",
          },
          type: "select",
        },
      },
    ],
  },
  {
    name: "Take a photo",
    image: "",
    muiIcon: iconCamera,
    action: {
      type: "select",
      descriptor: {
        CreateScreenshot: "_",
      },
    },
    subActions: [],
  },
];

export default list;
